import React from 'react'
import Fragment from '../common/fragment'


function FragmentBT(props) {
  return (
    <Fragment pos="tt" {...props}>
      <p>
“En 1900, Antonio empezó a trabajar con un fotógrafo alemán, Juan Kurt (J. C.

Curd) en Pátzcuaro; Juan se unió a él tres años después. Hacían teatro además de
fotografía; fundaron una compañía familiar de la farándula con otro hermano, Luis,
y viajaron por varios estados del centro del país (...) parece que tomaron varias
escenas de la toma de León, Guanajuato” (Mraz, 172).
      </p>
    </Fragment>
  )
}


export default FragmentBT
